import React, { useState } from 'react'
import logoImage from '../../assets/logo/logo.png'
import { Menu, X } from 'lucide-react'
import { track } from '../../utils/analytics'

const MarketingHeader: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <nav className="bg-white/80 backdrop-blur-sm border-b border-white/20 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <a href="/" className="flex items-center">
            <img src={logoImage} alt="2domy.pl logo" className="h-8 w-auto mr-3" />
            <span className="font-bold text-xl bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent">2domy.pl</span>
          </a>

          {/* Desktop Menu */}
          <div className="hidden sm:flex items-center space-x-2">
            <a href="/blog" className="px-2 text-sm text-slate-700 hover:text-slate-900 hover:underline" onClick={() => track('cta_click', { label: 'blog_nav' })}>Blog</a>
            <a href="/pricing" className="px-2 text-sm text-slate-700 hover:text-slate-900 hover:underline" onClick={() => track('cta_click', { label: 'pricing_nav' })}>Cennik</a>
            <a href="/auth/login" className="glass-button px-4 py-2 text-sm rounded-md" onClick={() => track('cta_click', { label: 'login_nav' })}>Zaloguj</a>
          </div>

          {/* Mobile menu button */}
          <div className="sm:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-slate-600 hover:text-slate-800"
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="sm:hidden bg-white/95 backdrop-blur-sm border-t border-white/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="/blog" className="w-full justify-center mb-2 inline-flex items-center text-center rounded-md text-slate-700 hover:text-slate-900" onClick={() => { track('cta_click', { label: 'blog_nav_mobile' }); setMobileMenuOpen(false) }}>Blog</a>
              <a href="/pricing" className="w-full justify-center mb-2 inline-flex items-center text-center rounded-md text-slate-700 hover:text-slate-900" onClick={() => { track('cta_click', { label: 'pricing_nav_mobile' }); setMobileMenuOpen(false) }}>Cennik</a>
              <a href="/auth/login" className="glass-button w-full justify-center mb-2 inline-flex items-center text-center rounded-md" onClick={() => { track('cta_click', { label: 'login_nav_mobile' }); setMobileMenuOpen(false) }}>Zaloguj</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default MarketingHeader


